interface FooterProps {
  socials: {
    facebook: string;
    instagram: string;
  };
}

export default function Footer({ socials }: FooterProps) {
  return (
    <footer className="border-t border-forest/10 bg-birch">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-8 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <img
            src="/icons/turtle-island-cottage-logo.png"
            alt=""
            width="48"
            height="48"
            className="h-12 w-12 object-contain"
            aria-hidden="true"
          />
          <p className="text-sm text-bark/55">
            © {new Date().getFullYear()} Turtle Island Cottage
          </p>
        </div>
        <div className="flex gap-4 text-sm">
          <a
            className="rounded-md px-2 py-1 text-bark/65 transition hover:text-forest focus:outline-hidden focus:ring-2 focus:ring-forest focus:ring-offset-2"
            href={socials.facebook}
            target="_blank"
            rel="noreferrer"
            aria-label="Visit our Facebook page"
          >
            Facebook
          </a>
          <a
            className="rounded-md px-2 py-1 text-bark/65 transition hover:text-forest focus:outline-hidden focus:ring-2 focus:ring-forest focus:ring-offset-2"
            href={socials.instagram}
            target="_blank"
            rel="noreferrer"
            aria-label="Visit our Instagram page"
          >
            Instagram
          </a>
        </div>
      </div>
    </footer>
  );
}
